import { useState } from 'react'
import { useNavigate, Link } from 'react-router-dom'
import { Leaf, UserPlus } from 'lucide-react'
import toast from 'react-hot-toast'
import api from '../../services/api'

export default function RegisterPage() {
  const navigate = useNavigate()
  const [loading, setLoading] = useState(false)
  const [formData, setFormData] = useState({
      cabinet_name: '',
      admin_name: '',
      email: '',
      password: ''
  })

  const onSubmit = async (e) => {
    e.preventDefault()
    setLoading(true)
    try {
      //await api.post('/api/auth/register', formData)
      //toast.success("Compte créé ! Vous pouvez vous connecter.")
      //navigate('/admin/login')
      toast.success("Ouverture prochaine des inscriptions.")
    } catch (error) {
      toast.error(error.response?.data?.detail || "Erreur d'inscription")
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="min-h-screen flex items-center justify-center p-4 bg-cover bg-center bg-fixed" style={{ backgroundImage: `linear-gradient(to bottom right, rgba(246, 247, 244, 0.90), rgba(254, 249, 195, 0.90)), url('/images/phenix.jpg')` }}>
      <div className="card max-w-md w-full relative z-10 shadow-2xl backdrop-blur-sm bg-white/95">
        
        <div className="text-center mb-8">
          <div className="w-16 h-16 bg-gradient-to-br from-sun-300 to-sage-200 rounded-full flex items-center justify-center mx-auto mb-4 shadow-inner">
            <Leaf className="w-8 h-8 text-sage-700" />
          </div>
          <h1 className="text-2xl font-serif text-sage-800 font-bold">Créer mon cabinet</h1>
          <p className="text-sage-600 mt-1">14 jours d'essai offerts, sans carte bancaire.</p>
        </div>

        <form onSubmit={onSubmit} className="space-y-4">
          <div>
            <label className="block text-xs font-bold text-gray-500 uppercase mb-1">Nom de votre cabinet</label>
            <input required value={formData.cabinet_name} onChange={e => setFormData({...formData, cabinet_name: e.target.value})} className="w-full bg-gray-50 focus:bg-white" placeholder="Ex: Cabinet Santé Sud" />
          </div>
          <div>
            <label className="block text-xs font-bold text-gray-500 uppercase mb-1">Votre Prénom et Nom</label>
            <input required value={formData.admin_name} onChange={e => setFormData({...formData, admin_name: e.target.value})} className="w-full bg-gray-50 focus:bg-white" placeholder="Ex: Marie Dupont" />
          </div>
          <div>
            <label className="block text-xs font-bold text-gray-500 uppercase mb-1">Email professionnel</label>
            <input type="email" required value={formData.email} onChange={e => setFormData({...formData, email: e.target.value})} className="w-full bg-gray-50 focus:bg-white" />
          </div>
          <div>
            <label className="block text-xs font-bold text-gray-500 uppercase mb-1">Mot de passe</label>
            <input type="password" required minLength="6" value={formData.password} onChange={e => setFormData({...formData, password: e.target.value})} className="w-full bg-gray-50 focus:bg-white" />
          </div>

          <button type="submit" disabled={loading} className="w-full btn btn-primary flex justify-center items-center gap-2 py-3 mt-2 shadow-lg">
            {loading ? <div className="spinner w-5 h-5 border-white"/> : <><UserPlus className="w-5 h-5"/> Démarrer l'essai</>}
          </button>
        </form>

        <p className="text-center text-sm text-gray-500 mt-6 pt-4 border-t border-gray-100">
            Vous avez déjà un compte ? <Link to="/admin/login" className="text-sage-600 font-bold hover:underline">Se connecter</Link>
        </p>
      </div>
    </div>
  )
}